/**
 * A forma de abrir cada seção do papel: quem abre folha nova e quem leva as
 * folhas de anotação antes de si.
 *
 * A ordem e a abertura vêm daqui, do motor, para a conta da paginação e o
 * desenho não divergirem: se o desenho põe `break-before`, a conta empurra — e
 * se a conta empurra uma seção para a folha seguinte, o desenho faz o mesmo.
 */
import { numerarSecoes, temConteudoImpresso } from './abnt.js';
import { folhasDeAnotacao, molduraDaFolha, posicaoDaAnotacao } from './folha.js';
/**
 * A abertura de cada seção, na ordem em que o papel as desenha.
 *
 * Só a seção primária (nível 1) abre folha nova — é o que a norma permite e o
 * que o modelo pede. As folhas de anotação `ENTRE_CAPITULOS` entram antes de
 * cada capítulo, menos o primeiro (não há nada antes dele para anotar).
 */
export function formaDeABRIR(documento) {
    const comCapitulos = documento.modelo === 'LIVRO';
    const moldura = molduraDaFolha(documento);
    const secoes = numerarSecoes(documento.secoes, comCapitulos ? { livro: true } : {}).filter((_, indice) => temConteudoImpresso(documento.secoes, indice));
    const capitulos = secoes.filter((item) => item.nivel === 1);
    const primeiroCapitulo = capitulos[0]?.secao.id;
    const anotacoesLigadas = documento.itens.includes('PAGINA_DE_ANOTACAO') && folhasDeAnotacao(documento) > 0;
    const entreCapitulos = anotacoesLigadas && posicaoDaAnotacao(documento) === 'ENTRE_CAPITULOS' && capitulos.length > 1;
    return secoes.map((item) => {
        const primaria = item.nivel === 1;
        return {
            id: item.secao.id,
            abreFolhaNova: primaria && Boolean(item.secao.novaPagina || moldura.capituloEmFolhaNova),
            folhasInteirasAntes: entreCapitulos && primaria && item.secao.id !== primeiroCapitulo
                ? folhasDeAnotacao(documento)
                : 0,
        };
    });
}
//# sourceMappingURL=abertura.js.map